import { render, staticRenderFns } from "./Report-hold-workshop.vue?vue&type=template&id=51573ab6"
import script from "./Report-hold-workshop.vue?vue&type=script&lang=js"
export * from "./Report-hold-workshop.vue?vue&type=script&lang=js"
import style0 from "./Report-hold-workshop.vue?vue&type=style&index=0&id=51573ab6&prod&lang=scss"
import style1 from "./Report-hold-workshop.vue?vue&type=style&index=1&id=51573ab6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports